// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3rnFG4Ap","text":"_iQKehl3L","hidden":"_fwTEyt4J","textColor":"_wqLeoNR0"};